<template>

  <v-dialog v-model="show" max-width="500" :hide-overlay="false">
     <template v-slot:activator="{ on }">
      <v-btn icon :dark="dark" slot="activator" v-on="on">
        <v-icon medium>{{icon}}</v-icon>
        {{text}}
      </v-btn>
    </template>

    <v-card class="wsr-infowin">
      <v-toolbar :color="color" class="" :dark="dark">
        <v-toolbar-side-icon><v-icon>{{ icon }}</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-side-icon @click="show=false"><v-icon>close</v-icon></v-toolbar-side-icon>
      </v-toolbar>

      <v-card-title primary-title class="wsr-text">
          <h3>Info</h3>

          <p>
            Weinstraßenreise zeigt die Ortschaften, die an der Deutschen Weinstraße
            zwischen Bockenheim und Schweigen liegen auf einer interaktiven Webkarte,
            einem sogenannten <a href="https://de.wikipedia.org/wiki/Web_GIS" target="_blank">WebGIS</a>.
            Neben der Karteninformation können zu
            jeder Ortschaft weiterführende Informationen abgerufen und angezeigt werden.
            Diese Informationen stammen aus der <a href="https://de.wikipedia.org/wiki/Wikipedia:Hauptseite" target="_blank">deutschsprachigen Wikipedia</a>.
          </p>

          <p>
            Die Kartenanwendung basiert auf freien Geodaten (<a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a>),
            sowie auf freier und quelloffener Software (u.a. <a href="https://meggsimum.de/wegue/" target="_blank">Wegue</a>).
            Die OpenStreetMap Daten wurden mit der Software <a href="https://qgis.org/en/site/" target="_blank">QGIS</a> aufbereitet.
          </p>

          <h3>Idee, Entwicklung und Bereitstellung</h3>
          <a href="https://meggsimum.de/" target="_blank">
            <v-img
              :src="logoSrc"
              contain
              aspect-ratio="2.5"
              min-width="290"
            ></v-img>
          </a>
          <p>
            Christian Mayer<br>
            Schillerstraße 2a<br>
            67112 Mutterstadt<br><br>
            Falls Sie Fragen, Anregungen oder Interesse an einer solchen
            Kartenanwendung haben können Sie über die Email-Adresse
            <a href="mailto:info@meggsimum.de" target="_blank">info-(at)-meggsimum-(punkt)-de</a>
            mit uns in Kontakt treten.
          </p>

          <h3>Credits / Lizenzangaben</h3>
          <p>
            Detailtexte aus Wikipedia sind unter der Lizenz
            „<a href="https://de.wikipedia.org/wiki/Wikipedia:Lizenzbestimmungen_Commons_Attribution-ShareAlike_3.0_Unported" target="_blank">Creative Commons Attribution/Share Alike</a>“
            verfügbar.
            <br>
            Informationen zu den Urhebern und zum Lizenzstatus eingebundener Mediendateien (Bilder)
            können im Regelfall durch Anklicken dieser abgerufen werden (wenn nicht anderweitig angegeben).
          </p>
          <p class="wsr-icon-text">
            <img src="static/data/wnstr-reise/vineyard-white.png" alt="">
             -Icon mit <a href="https://mapicons.mapsmarker.com/" target="_blank">Maps Icons Collection</a> erstellt, lizenziert unter
             <a href="http://creativecommons.org/licenses/by-sa/3.0/" target="_blank">Creative Commons Attribution-Share Alike 3.0 Unported</a>
          </p>
          <p class="wsr-icon-text">
            <img src="static/data/wnstr-reise/deutsche-weinstrasse.svg" alt="" height="30">
             -Icon im Original von <a href="https://commons.wikimedia.org/wiki/User:Skarabeusz" target="_blank">Skarabeusz</a> erstellt,
             lizensiert unter <a href="https://en.wikipedia.org/wiki/en:GNU_Free_Documentation_License" target="_blank"></a>GNU Free Documentation License
             bezogen über <a href="https://commons.wikimedia.org/wiki/File:Deutsche-Weinstrasse.svg" target="_blank">Wikimedia Commons</a>
          </p>
          <p>
            Kartendaten (Orte): © <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>-Mitwirkende,
            lizenziert unter <a href="http://opendatacommons.org/licenses/odbl/" target="_blank">Open Data Commons Open Database License (ODbL)</a>
          </p>
          <p>
            Hintergrundkarte (WMS): © <a href="http://www.mundialis.de/" target="_blank">mundialis</a>
          </p>
      </v-card-title>

    </v-card>

  </v-dialog>

</template>

<script>

export default {
  name: 'wsr-infowin',
  props: {
    color: {type: String, required: false, default: 'rgba(135, 211, 124, 1)'},
    icon: {type: String, required: false, default: 'info'},
    dark: {type: Boolean, required: false, default: false},
    title: {type: String, required: false, default: 'Über Weinstraßenreise'},
    text: {type: String, required: false}
  },
  data () {
    return {
      show: false,
      logoSrc: 'static/data/wnstr-reise/meggsimum-logo-s-rgb-980.jpg'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  a {
    color: #d82946;
  }

  .wsr-icon-text img {
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// app/components/InfoWin.vue